export default __webpack_public_path__ + "static/media/logout_icon.2bc5676e.svg";